import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import PageContentEditor from "../../../components/PageContentEditor";
import { DataCodeEnum } from "../../../constants/enum";

// import ZodiacList from "./components/ZodiacList";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: "100%", height: "100%" }}>{children}</Box>
      )}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MeaningOfNumbers = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const tabs = [
    {
      code: "Introduction",
      name: "Introduction",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_INTRODUCTION}
          dataName={"Introduction"}
        />
      ),
    },
    {
      code: "Number_1",
      name: "Number 1",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_1}
          dataName={"Number 1"}
        />
      ),
    },
    {
      code: "Number_2",
      name: "Number 2",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_2}
          dataName={"Number 2"}
        />
      ),
    },
    {
      code: "Number_3",
      name: "Number 3",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_3}
          dataName={"Number 3"}
        />
      ),
    },
    {
      code: "Number_4",
      name: "Number 4",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_4}
          dataName={"Number 4"}
        />
      ),
    },
    {
      code: "Number_5",
      name: "Number 5",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_5}
          dataName={"Number 5"}
        />
      ),
    },
    {
      code: "Number_6",
      name: "Number 6",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_6}
          dataName={"Number 6"}
        />
      ),
    },
    {
      code: "Number_7",
      name: "Number 7",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_7}
          dataName={"Number 7"}
        />
      ),
    },
    {
      code: "Number_8",
      name: "Number 8",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_8}
          dataName={"Number 8"}
        />
      ),
    },
    {
      code: "Number_9",
      name: "Number 9",
      component: () => (
        <PageContentEditor
          dataCode={DataCodeEnum.MEANING_OF_NUMBERS_9}
          dataName={"Number 9"}
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab
              label={tab.name}
              {...a11yProps(index)}
              sx={{
                textTransform: "unset",
                "&.Mui-selected": {
                  fontWeight: "bold",
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel value={value} index={index}>
          {<tab.component />}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

export default MeaningOfNumbers;
